import { useState } from "react";
import { useApp } from "../App";

import "../styles/Footer.css";
import { Link } from "react-router-dom";

export default function Footer({ navigate }) {
  const { showToast } = useApp();
  const [email, setEmail] = useState("");
  const [showBulkForm, setShowBulkForm] = useState(false);

  // B2B Form state
  const [bulkForm, setBulkForm] = useState({
    name: "",
    businessName: "",
    email: "",
    phone: "",
    productInterest: "",
    quantity: "",
    city: "",
    state: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      showToast("Please enter a valid email.", "error");
      return;
    }
    showToast("Subscribed successfully! Welcome to Nandu family 🎉", "success");
    setEmail("");
  };

  const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };

  const handleBulkInputChange = (e) => {
    const { name, value } = e.target;
    setBulkForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !bulkForm.name.trim() ||
      !bulkForm.email.trim() ||
      !bulkForm.phone.trim()
    ) {
      showToast("Please fill in all required fields.", "error");
      return;
    }

    if (!bulkForm.email.includes("@")) {
      showToast("Please enter a valid email address.", "error");
      return;
    }

    if (bulkForm.phone.length < 10) {
      showToast("Please enter a valid 10-digit phone number.", "error");
      return;
    }

    setIsSubmitting(true);

    // Simulate API call - Replace with your actual backend endpoint
    try {
      // const response = await fetch("/api/bulk-enquiry", {
      //     method: "POST",
      //     headers: { "Content-Type": "application/json" },
      //     body: JSON.stringify(bulkForm)
      // });

      // Simulate network delay
      await new Promise((resolve) => setTimeout(resolve, 1000));

      showToast(
        "Bulk enquiry submitted successfully! Our team will contact you within 24 hours.",
        "success",
      );
      setShowBulkForm(false);
      setBulkForm({
        name: "",
        businessName: "",
        email: "",
        phone: "",
        productInterest: "",
        quantity: "",
        city: "",
        state: "",
        message: "",
      });
    } catch (error) {
      showToast("Something went wrong. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="footer-grid">
            {/* Brand */}
            <div className="hp-footer-brand">
              <Link to="/" className="hp-footer-logo">
                <img src="/assets/kkblogo.png" alt="KKB & Co." />
                <span>KKB</span>
              </Link>
              <p className="hp-footer-brand-desc">
                Heritage textiles from Tamil Nadu — handwoven by artisans who
                have practised this craft for generations.
              </p>
              <div className="hp-footer-socials">
                {[
                  {
                    label: "Instagram",
                    href: "https://instagram.com/mynanduonline",
                    icon: (
                      <svg
                        viewBox="0 0 24 24"
                        width="17"
                        height="17"
                        fill="currentColor"
                      >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    ),
                  },
                  {
                    label: "Facebook",
                    href: "https://facebook.com/mynanduonline",
                    icon: (
                      <svg
                        viewBox="0 0 24 24"
                        width="17"
                        height="17"
                        fill="currentColor"
                      >
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                      </svg>
                    ),
                  },
                  {
                    label: "YouTube",
                    href: "https://youtube.com",
                    icon: (
                      <svg
                        viewBox="0 0 24 24"
                        width="17"
                        height="17"
                        fill="currentColor"
                      >
                        <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />
                      </svg>
                    ),
                  },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    className="hp-footer-social"
                    aria-label={s.label}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Shop */}
            <div className="footer-col">
              <h4>Shop</h4>
              <ul>
                <li>
                  <button
                    className="footer-link"
                    onClick={() =>
                      handleNavigation("/collection", {
                        category: "Men",
                        collection: "all",
                      })
                    }
                  >
                    Men's Lungies
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() =>
                      handleNavigation("/collection", {
                        category: "Boys",
                        collection: "boys",
                      })
                    }
                  >
                    Boys Lungies
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() =>
                      handleNavigation("/collection", {
                        category: "Handkerchief",
                        collection: "handkerchief",
                      })
                    }
                  >
                    Hand Kerchief
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() =>
                      handleNavigation("/collection", {
                        category: "Towels",
                        collection: "towels",
                      })
                    }
                  >
                    Towels
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() =>
                      handleNavigation("/collection", {
                        category: "Dhothis",
                        collection: "dhothis",
                      })
                    }
                  >
                    Dhothis
                  </button>
                </li>
              </ul>
            </div>

            {/* Bulk Orders - New Section */}
            {/* In footer-col, replace B2B section */}
            <div className="footer-col">
              <h4>B2B / Bulk Orders</h4>
              <ul>
                <li>
                  <button
                    className="footer-link bulk-order-btn"
                    onClick={() => navigate("/b2b")}
                  >
                    Wholesale Enquiry
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link bulk-order-btn"
                    onClick={() => navigate("/b2b?type=corporate")}
                  >
                    Corporate Orders
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link bulk-order-btn"
                    onClick={() => navigate("/b2b?type=retailer")}
                  >
                    Retailer Partnership
                  </button>
                </li>
              </ul>
              <div
                style={{
                  marginTop: 16,
                  fontSize: 13,
                  color: "var(--text-muted)",
                }}
              >
                <div>📞 Bulk Enquiry: +91 98439 61449</div>
                <div>✉ bulk@mynandu.com</div>
              </div>
            </div>

            {/* Contact */}
            <div className="footer-col">
              <h4>Contact</h4>
              <div className="footer-address">
                46 A, Panapakkam Road,
                <br />
                Nemili, Ranipet,
                <br />
                TamilNadu, India – 631 051
              </div>
              <div className="footer-contact">
                <a href="tel:+919843961449">📞 +91 98439 61449</a>
                <a href="mailto:support@mynandu.com">✉ support@mynandu.com</a>
              </div>
              <ul style={{ marginTop: 12 }}>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/about")}
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/contact")}
                  >
                    Contact Us
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/track")}
                  >
                    Track Order
                  </button>
                </li>
              </ul>
            </div>

            {/* Info */}
            <div className="footer-col">
              <h4>Info</h4>
              <ul>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/about")}
                  >
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/about")}
                  >
                    Refund Policy
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/about")}
                  >
                    Shipping Policy
                  </button>
                </li>
                <li>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/about")}
                  >
                    Terms of Service
                  </button>
                </li>
              </ul>

              <div style={{ marginTop: 24 }}>
                <h4
                  style={{
                    fontSize: 11,
                    fontWeight: 800,
                    letterSpacing: 2,
                    textTransform: "uppercase",
                    color: "var(--gold)",
                    marginBottom: 12,
                  }}
                >
                  We Accept
                </h4>
                <div
                  className="payment-icons"
                  style={{ display: "flex", flexWrap: "wrap", gap: 6 }}
                >
                  {["VISA", "MC", "UPI", "AMEX", "NET"].map((p) => (
                    <span key={p} className="payment-icon">
                      {p}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <p>© 2026 KKBalusamy & Co. — All Rights Reserved</p>
            <div className="footer-bottom-links">
              <button
                className="footer-link"
                onClick={() => navigate("/about")}
              >
                Privacy
              </button>
              <button
                className="footer-link"
                onClick={() => navigate("/about")}
              >
                Refund
              </button>
              <button
                className="footer-link"
                onClick={() => navigate("/about")}
              >
                Shipping
              </button>
              <button
                className="footer-link"
                onClick={() => navigate("/about")}
              >
                Terms
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Bulk Order Modal */}
      {showBulkForm && (
        <div
          className="bulk-modal-overlay"
          onClick={() => setShowBulkForm(false)}
        >
          <div className="bulk-modal" onClick={(e) => e.stopPropagation()}>
            <div className="bulk-modal-header">
              <h2>Bulk Order / Wholesale Enquiry</h2>
              <button
                className="bulk-modal-close"
                onClick={() => setShowBulkForm(false)}
              >
                ×
              </button>
            </div>

            <div className="bulk-modal-body">
              <div className="bulk-info-section">
                <p>
                  Looking to purchase lungies, dhothis, or towels in bulk? At
                  KKBalusamy & Co., we offer high-quality products at special
                  wholesale pricing for retailers, resellers, corporate clients,
                  and bulk buyers.
                </p>

                <div className="bulk-features">
                  <div className="bulk-feature">
                    <strong>🎯 Wholesale Pricing</strong>
                    <span>Best market rates for bulk quantities</span>
                  </div>
                  <div className="bulk-feature">
                    <strong>📦 Pan India Delivery</strong>
                    <span>Safe packaging & doorstep delivery</span>
                  </div>
                  <div className="bulk-feature">
                    <strong>🎨 Customization Available</strong>
                    <span>Color matching & design repetition</span>
                  </div>
                  <div className="bulk-feature">
                    <strong>🏪 Trusted by 500+ Retailers</strong>
                    <span>Across TamilNadu & beyond</span>
                  </div>
                </div>

                <div className="bulk-contact-info">
                  <h4>📞 Direct Contact</h4>
                  <p>
                    Call or WhatsApp: <strong>+91 98439 61449</strong>
                  </p>
                  <p>
                    Email: <strong>bulk@mynandu.com</strong>
                  </p>
                </div>
              </div>

              <form onSubmit={handleBulkSubmit} className="bulk-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={bulkForm.name}
                      onChange={handleBulkInputChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Business Name</label>
                    <input
                      type="text"
                      name="businessName"
                      value={bulkForm.businessName}
                      onChange={handleBulkInputChange}
                      placeholder="Your store/company name"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={bulkForm.email}
                      onChange={handleBulkInputChange}
                      placeholder="your@email.com"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={bulkForm.phone}
                      onChange={handleBulkInputChange}
                      placeholder="10-digit mobile number"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Product Interest *</label>
                    <select
                      name="productInterest"
                      value={bulkForm.productInterest}
                      onChange={handleBulkInputChange}
                      required
                    >
                      <option value="">Select product category</option>
                      <option value="Men's Lungies">Men's Lungies</option>
                      <option value="Boys Lungies">Boys Lungies</option>
                      <option value="Dhothis">Dhothis</option>
                      <option value="Towels">Towels</option>
                      <option value="Handkerchief">Handkerchief</option>
                      <option value="Mixed Products">Mixed Products</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Approx. Quantity</label>
                    <select
                      name="quantity"
                      value={bulkForm.quantity}
                      onChange={handleBulkInputChange}
                    >
                      <option value="">Select quantity range</option>
                      <option value="50-100 pieces">50-100 pieces</option>
                      <option value="101-250 pieces">101-250 pieces</option>
                      <option value="251-500 pieces">251-500 pieces</option>
                      <option value="501-1000 pieces">501-1000 pieces</option>
                      <option value="1000+ pieces">1000+ pieces</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      value={bulkForm.city}
                      onChange={handleBulkInputChange}
                      placeholder="Your city"
                    />
                  </div>
                  <div className="form-group">
                    <label>State</label>
                    <input
                      type="text"
                      name="state"
                      value={bulkForm.state}
                      onChange={handleBulkInputChange}
                      placeholder="Your state"
                    />
                  </div>
                </div>

                <div className="form-group full-width">
                  <label>Additional Message / Requirements</label>
                  <textarea
                    name="message"
                    value={bulkForm.message}
                    onChange={handleBulkInputChange}
                    rows="4"
                    placeholder="Tell us about your specific requirements, preferred designs, colors, or any customization needs..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="bulk-submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit Bulk Enquiry"}
                </button>

                <p className="bulk-form-note">
                  * Our team will contact you within 24 hours with pricing and
                  catalog details.
                </p>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
